// 카리페이 콘솔 상수. 카리아카 const.js 에서 콘솔이 실제로 쓰는 값만 남겼다.
//
// API_URL 기본값은 카리페이 청구 서버다. 카리아카 API(api.dev.chewing.io)로 두면 SSM 에 키가 빠졌을 때
// 가맹점 요청이 카리아카 DB 로 들어간다 — 절대 바꾸지 않는다.
const API_URL = process.env.REACT_APP_API_URL || "https://api.dev.caripay.co.kr";

// 카리페이 랜딩(caripay.co.kr). 문의·약관·도입 신청이 여기 있다.
const SITE_URL = "https://caripay.co.kr";

module.exports = {
  API_URL,
  SITE_URL,

  SERVICE_NAME: "카리페이",

  // 문의 창구 — "상담·문의" 버튼은 모두 이 값만 쓴다(하드코딩 금지).
  CONTACT_URL: `${SITE_URL}/contact`,
  ONBOARDING_URL: process.env.REACT_APP_ONBOARDING_URL || `${SITE_URL}/start`,

  HEADER: {
    AUTH_TOKEN: "x-access-token",
    REFRESH_TOKEN: "x-refresh-token",
    CONTENT_TYPE: {
      NAME: "Content-Type",
      JSON: "application/json",
      FILE: "multipart/form-data",
      FORM: "application/x-www-form-urlencoded",
    },
    LANG: "Accept-Language",
  },

  //. 각종 시간/일자 포맷
  FORMAT: {
    DATE_TIME: "YYYY-MM-DD HH:mm:ss",
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm:ss",
    MONTH: "YYYY-MM",
    YEAR: "YYYY",
  },

  //. 응답코드
  RESULT_CODE: {
    SUCCESS: 0, //. 정상
    EMPTY_TOKEN: -1, //. 토큰정보 없음.
    TOKEN_EXPIRED: -2, //. 토큰 기한 만료
    EMPTY_PARAM: -3, //. 요청파라미터 누락
    ERROR: -10, //. api 내부 오류
    CUSTOM_ERROR: -4, //. 커스텀 오류
  },
};
